import {takeEvery} from "redux-saga/effects";
import * as ActionsTypes from "../../constants/stateConstants";
import {localReferentielSaga} from "./localReferentielSaga";

export default function* localReferentielWatcher() {
  yield takeEvery(ActionsTypes.LOCAL_REFERENTIEL, localReferentielSaga);
}
